import { render, staticRenderFns } from "./exercisesSC.vue?vue&type=template&id=07dc4556&scoped=true"
import script from "./exercisesSC.vue?vue&type=script&lang=js"
export * from "./exercisesSC.vue?vue&type=script&lang=js"
import style0 from "./exercisesSC.vue?vue&type=style&index=0&id=07dc4556&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07dc4556",
  null
  
)

export default component.exports